import { useEffect, useState } from "react";
import { ClipboardList } from "lucide-react";
import { notify, numberWithCommas } from "../../../helpers";
import ExIpaDataTable from "../../DataTable/ExIpaDataTable";
import DataTablePagination from "../../DataTablePagination";
import ExIpaEditModal from "../../Modal/ExIpaEditModal";
import { fetchExIpas } from "../../../services/exIpa";
import Spacing from "../../Spacing";

export default function ExIpa() {
  const [dataLoading, setDataLoading] = useState(true);
  const [exIpaData, setExIpaData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    per_page: 10,
    search_term: "",
  });

  const [paginationCount, setPaginationCount] = useState({
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    loadData(filter);
  }, [filter]);

  const loadData = async (filterData) => {
    setDataLoading(true);
    try {
      const response = await fetchExIpas(filterData);

      setExIpaData(response?.data?.results || []);
      setPaginationCount({
        totalCount: response?.data?.count,
        totalPages: response?.data?.total_pages,
      });
    } catch (error) {
      notify("error", "Failed to load data");
    } finally {
      setDataLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setFilter({ ...filter, page });
  };

  const handleChangeRowsPerPage = (value) => {
    setFilter({ ...filter, per_page: value, page: 1 });
  };

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          <i className="docpro_blue_bg docpro_white_color">
            <ClipboardList width={20} height={20} />
          </i>
          Ex IPA
          <span>{numberWithCommas(paginationCount.totalCount)}</span>
        </h2>
      </div>

      <Spacing lg="5" sm="5" />

      <div className="docpro_data_table_wrap">
        <ExIpaDataTable
          tableData={exIpaData}
          dataLoading={dataLoading}
          onEdit={(row) => setSelectedRow(row)}
        />

        {exIpaData.length > 0 && (
          <DataTablePagination
            currentPage={filter.page}
            totalPages={paginationCount.totalPages}
            totalRecords={paginationCount.totalCount}
            onPageChange={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            currentPageData={filter.per_page}
          />
        )}
      </div>

      {selectedRow && (
        <ExIpaEditModal
          data={selectedRow}
          reloadData={() => loadData(filter)}
          onClose={() => setSelectedRow(null)}
        />
      )}
    </>
  );
}
